import moment from 'moment/moment';
import { useState } from 'react';
import TemplateFilter from './components/TemplateFilter';
import useSearchString from '../../hooks/UrlParamsHandler/useSearchParams';
import { CalendarPageHeader } from './CalendarPageHeader';
import { CalendarPageContent } from './CalendarPageContent';
import { CalendarPageSidebarModal } from './CalendarPageSidebarModal';
import getResponseArray from '@tymbe/utils/getResponseArray';
import { useCalendarShifts } from './calendarPageUtils';
import { FilterProvider } from './FilterContext';
import CompanyFilterModal from './CompanyFilterModal';
import ShiftDetailModal from './components/ShiftDetailModal';
import { useAdminPopup } from '../../hooks/useAdminPopup';
import AdminPopupModal from './AdminPopupModal';

const CalendarPage = () => {
  const [templates, setTemplates] = useState<number[]>([]);

  const now = moment().startOf('week').toISOString();

  const [searchParams] = useSearchString();

  const start = searchParams.get('start') ?? now;
  const shiftFilter = searchParams.get('shiftFilter') || undefined;

  const companyIdFromURL = Number(searchParams.get('company_id')) || undefined;
  const branchofficeIdFromURL = Number(searchParams.get('branchoffice_id')) || undefined;
  const departmentIdFromURL = Number(searchParams.get('department_id')) || undefined;

  const shiftReq = useCalendarShifts(start, {
    templates,
    shiftFilter,
    companyId: companyIdFromURL,
    branchofficeId: branchofficeIdFromURL,
    departmentId: departmentIdFromURL,
  });

  const shifts = getResponseArray(shiftReq.data);

  const { showPopup, popupData, handleClosePopup } = useAdminPopup({ module: 'calendar' });

  return (
    <FilterProvider>
      <CalendarPageHeader start={start} end={moment(start).endOf('week').toISOString()} />
      <TemplateFilter
        start={start}
        companyId={companyIdFromURL}
        branchofficeId={departmentIdFromURL}
        onChange={setTemplates}
      />
      <CalendarPageContent shifts={shifts} isLoading={shiftReq.isLoading} isFetched={shiftReq.isFetched} />
      <CalendarPageSidebarModal shiftRequestRefetch={shiftReq.refetch} />

      <ShiftDetailModal className="absolute h-full top-0 right-0 w-full md:w-[400px] min-[1000px]:flex hidden lg:hidden !rounded-3xl" />
      <CompanyFilterModal className="absolute h-full top-0 right-0 w-full md:w-[400px] z-50" start={start} end={moment(start).endOf('week').toISOString()} />

      {/* Admin Popup Modal */}
      <AdminPopupModal showPopup={showPopup} popupData={popupData} handleClosePopup={handleClosePopup} />
    </FilterProvider>
  );
};

export default CalendarPage;
